import isPlainObject from"./isPlainObject";export function isObject(payload){return isPlainObject(payload)}export default isObject;